import { useMemo } from 'react';

import Decimal from 'decimal.js';

interface UsePriceForPreviewParams {
  price: number;
  setAsFree?: boolean;
}

interface UsePriceForPreviewResult {
  priceDisplay: string;
  priceInUsdCents: number;
}

export const usePriceForPreview = ({
  price,
  setAsFree
}: UsePriceForPreviewParams): UsePriceForPreviewResult => {
  const priceDisplay = useMemo((): string => {
    if (setAsFree || !price) return '$0.00';
    try {
      return `$${new Decimal(price).toFixed(2)}`;
    } catch {
      return '$0.00';
    }
  }, [price, setAsFree]);

  const priceInUsdCents = useMemo((): number => {
    if (setAsFree || !price) return 0;
    try {
      return new Decimal(price).mul(100).toNumber();
    } catch {
      return 0;
    }
  }, [price, setAsFree]);

  return { priceDisplay, priceInUsdCents };
};
